module.exports = __webpack_public_path__ + "img/cta-sport-fr.69cb6378.png";